import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./StaticPageBlock').then(m => ({default: m.StaticPageBlock})),
)

export const staticPageBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
